__turbopack_context__.v({
  "className": "fontsans_2dcbbc2d-module__Nr2rQW__className",
  "variable": "fontsans_2dcbbc2d-module__Nr2rQW__variable",
});
